import Breadcrumb from '@amzn/meridian/breadcrumb';
import { localizeWithRef } from './localize';

export default localizeWithRef(Breadcrumb, ['children']);
